import { render, staticRenderFns } from "./TipDetail.vue?vue&type=template&id=a40f08cc&scoped=true&"
import script from "./TipDetail.vue?vue&type=script&lang=js&"
export * from "./TipDetail.vue?vue&type=script&lang=js&"
import style0 from "./TipDetail.vue?vue&type=style&index=0&id=a40f08cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a40f08cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VImg,VLayout,VRow})
